'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { motion } from 'framer-motion';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { IoIosStar } from 'react-icons/io';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export function ReviewsCarousel({ className }: { className?: string }) {
  const data = [
    {
      description:
        '<p>„Cením si, že mi poradili aj s praktickými detailmi, na ktoré by som sama nemyslela. Vstavaná skriňa je krásna a maximálne funkčná.“</p>',
      name: 'Peter O.',
    },
    {
      description:
        '<p>„Cením si, že mi poradili aj s praktickými detailmi, na ktoré by som sama nemyslela. Vstavaná skriňa je krásna a maximálne funkčná.“</p>',
      name: 'Peter O.',
    },
    {
      description:
        '<p>„Cením si, že mi poradili aj s praktickými detailmi, na ktoré by som sama nemyslela.“</p>',
      name: 'Peter O.',
    },
    {
      description:
        '<p>„Cením si, že mi poradili aj s praktickými detailmi, na ktoré by som sama nemyslela. Vstavaná skriňa</p>',
      name: 'Peter O.',
    },
  ];

  const reviews = [...data, ...data];

  const animationDuration = 30;

  return (
    <section className={cn('custom-section', 'px-0', className)}>
      <div className="w-full overflow-hidden">
        <motion.div
          className="flex gap-4"
          animate={{ x: ['0%', '-50%'] }}
          transition={{
            duration: animationDuration,
            ease: 'linear',
            repeat: Infinity,
          }}
        >
          {reviews.map((item, index) => (
            <div
              key={index}
              className="flex w-[260px] flex-shrink-0 flex-col items-center justify-center gap-4 bg-primary-foreground p-4 shadow-sm sm:p-6 md:w-[384px] lg:p-8"
            >
              <div className="flex w-full items-center justify-between">
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <IoIosStar key={i} className="h-[18px] w-[18px] text-primary sm:h-5 sm:w-5" />
                  ))}
                  <p className="ml-1 text-sm md:text-base">5/5</p>
                </div>
                <Image
                  src="/images/google-logo.svg"
                  alt="Google"
                  width={24}
                  height={24}
                  className="h-[22px] w-auto sm:h-[24px] md:h-[26px]"
                />
              </div>
              <div className={cn('h-[1px] w-full', 'ea-reviews-carousel__divider')} />
              <HtmlRendererRaw
                className={cn(
                  'line-clamp-4 max-h-[84px] min-h-[84px] w-full text-center md:max-h-24 md:min-h-24',
                  'ea-reviews-carousel__description',
                )}
                html={item.description}
              />
              <div className={cn('h-[1px] w-full', 'ea-reviews-carousel__divider')} />
              <p className="w-full text-center text-sm font-medium md:text-base">{item.name}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
